import React from 'react';
import PropTypes from 'prop-types';

const IconSearch = ({ width, height, fill }) => (
    <svg
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
    >
        <path d="M19.536 33.301c-7.582 0-13.75-6.167-13.75-13.749 0-7.582 6.168-13.751 13.75-13.751s13.75 6.17 13.75 13.751c0 7.582-6.168 13.749-13.75 13.749m27.487 11.417L32.675 30.367a17.182 17.182 0 0 0 3.802-10.776c0-9.426-7.62-17.091-16.988-17.091C10.12 2.5 2.5 10.165 2.5 19.591c0 9.423 7.62 17.091 16.989 17.091 3.99 0 7.852-1.414 10.901-3.983l14.328 14.324c.317.319.735.477 1.153.477.417 0 .835-.158 1.152-.477.309-.307.48-.717.477-1.155 0-.435-.168-.846-.477-1.15" />
    </svg>
);

IconSearch.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconSearch.defaultProps = {
    fill: '#343434',
    className: '',
    width: 20,
    height: 20,
};

export default IconSearch;
